/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Moderate_Promote_GlobalInputs */



/**
* | output |
* | --- |
* | "Pin globally" |
*
* @param {Community_Moderate_Promote_GlobalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_moderate_promote_global = /** @type {((inputs?: Community_Moderate_Promote_GlobalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Moderate_Promote_GlobalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Épingler mondialement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fijar globalmente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fixar globalmente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fissa globalmente")
	return /** @type {LocalizedString} */ ("Pin globally")
});